import { Component } from '@angular/core';

@Component({
  selector: 'app-comparison-retirement-types-esps',
  templateUrl: './comparison-retirement-types-esps.component.html',
  styleUrls: ['./comparison-retirement-types-esps.component.scss']
})
export class ComparisonRetirementTypesEspsComponent {

}
